import { render, staticRenderFns } from "./GiftListPopup.vue?vue&type=template&id=57bb6ef8&scoped=true&"
import script from "./GiftListPopup.vue?vue&type=script&lang=js&"
export * from "./GiftListPopup.vue?vue&type=script&lang=js&"
import style0 from "./GiftListPopup.vue?vue&type=style&index=0&id=57bb6ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb6ef8",
  null
  
)

component.options.__file = "GiftListPopup.vue"
export default component.exports